module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_four-4372180533a1436d87c9e229d13101eb.jpg";